import { Observable } from 'rxjs';

export class ShowError {
  static readonly type = '[Error message] Show error';
  constructor(readonly payload: Error) {}
}

export interface BlockingWarningDialogData {
  title: string;
  message: string;
  actionLabel: string;
  actionPath: string[];
}

export class ShowBlockingWarning {
  static readonly type = '[Error message] Show blocking warning';
  constructor(readonly payload: BlockingWarningDialogData) {}
}

/**
 * Fallo al imprimir el rotulo en la Zebra.
 *
 * `loadPreview` se evalua solo cuando el operador pide la vista previa: es una
 * contencion manual, no se dispara sola. Se pasa como funcion para que la
 * llamada HTTP siga viviendo en el data access de la feature (con su base url,
 * sus reintentos y sus interceptors) sin que este store dependa de ella.
 */
export interface LabelPrintFailureDialogData {
  message: string;
  loadPreview: () => Observable<Blob>;
}

export class ShowLabelPrintFailure {
  static readonly type = '[Error message] Show label print failure';
  constructor(readonly payload: LabelPrintFailureDialogData) {}
}
